/* istanbul ignore file */
import { LoadingAction, loadingReducer, LoadingStore } from "@wisr/common";
import { applyMiddleware, combineReducers, createStore } from "redux";
import { combineEpics, createEpicMiddleware } from "redux-observable";

import { AggregatorAction } from "./aggregator/aggregator.actions";
import { getAggregatorEpic } from "./aggregator/aggregator.epic";
import {
  aggregatorReducer,
  AggregatorState,
} from "./aggregator/aggregator.reducer";
import { ApplicationAction } from "./application/application.actions";
import {
  clearApplicationEpic,
  getApplicationContinueTokenEpic,
  getApplicationEpic,
  saveApplicationEpic,
  submitApplicationEpic,
} from "./application/application.epic";
import {
  applicationReducer,
  ApplicationState,
} from "./application/application.reducer";
import { CustomerAction } from "./customer/customer.actions";
import { customerReducer, CustomerState } from "./customer/customer.reducer";
import { EstimateAction } from "./estimate/estimate.actions";
import {
  acceptEstimateEpic,
  createEstimateEpic,
  getEstimateEpic,
  setAmountEpic,
  setLoantermEpic,
  updateQuoteJourneyEpic,
} from "./estimate/estimate.epic";
// Estimate
import { estimateReducer, EstimateState } from "./estimate/estimate.reducer";
import { PartnerReferralAction } from "./partner-referral/partner-referral.actions";
import { getPartnerReferralEpic } from "./partner-referral/partner-referral.epic";
import { PartnerReferralState } from "./partner-referral/partner-referral.reducer";
import { partnerReferralReducer } from "./partner-referral/partner-referral.reducer";
import { quoteFormReducer, QuoteFormState } from "./quote/quote-form.reducer";
import { TermsAction } from "./quote/terms/terms.actions";
import { getTermsEpic } from "./quote/terms/terms.epic";
import { termsReducer, TermsState } from "./quote/terms/terms.reducer";
import { NoopAction } from "./shared/common.actions";

const epics = combineEpics(
  createEstimateEpic,
  getEstimateEpic,
  setLoantermEpic,
  setAmountEpic,
  updateQuoteJourneyEpic,
  getAggregatorEpic,
  getApplicationEpic,
  getApplicationContinueTokenEpic,
  saveApplicationEpic,
  submitApplicationEpic,
  clearApplicationEpic,
  acceptEstimateEpic,
  getPartnerReferralEpic,
  getTermsEpic
);
const epicMidleware = createEpicMiddleware<
  AppAction,
  AppAction,
  AppStore,
  /* eslint-disable @typescript-eslint/no-explicit-any */
  any
>();

/* eslint-disable @typescript-eslint/no-explicit-any */
export const store = createStore<AppStore, any, any, any>(
  combineReducers({
    estimateState: estimateReducer,
    loadingState: loadingReducer,
    customerState: customerReducer,
    quoteFormState: quoteFormReducer,
    aggregatorState: aggregatorReducer,
    applicationState: applicationReducer,
    partnerReferralState: partnerReferralReducer,
    termsState: termsReducer,
  }),
  applyMiddleware(epicMidleware)
);

epicMidleware.run(epics);

export interface AppStore extends LoadingStore {
  estimateState: EstimateState;
  customerState: CustomerState;
  quoteFormState: QuoteFormState;
  aggregatorState: AggregatorState;
  applicationState: ApplicationState;
  partnerReferralState: PartnerReferralState;
  termsState: TermsState;
}

export type AppAction =
  | EstimateAction
  | ApplicationAction
  | CustomerAction
  | LoadingAction
  | AggregatorAction
  | PartnerReferralAction
  | TermsAction
  | NoopAction;
